<template lang="html">
  <transition name="fadeInSubtle">
    <div class="login-screen">

      <div class="loader-wrapper">
        <div v-show="isLoading" class="loader"></div>
      </div>

      <div v-show="!isLoading" class="login-wrapper">

        <div v-if="!passwordChanged && !tokenError">
          <h2 class="header">{{ $t('login.change_password') }}</h2>

          <hr />
          <h4 class="email-address">{{ credentials.email }}</h4>
          <p class="login-info">{{ $t('login.change_password_details') }}</p>

          <form class="form" @submit.prevent="submit()" @keyup.13>

            <label class="form__label">
              <input
                type="password"
                class="form__credentials-input"
                v-model="credentials.password"
                :placeholder="$t('login.new_password')"
                name="password"
                v-validate="'required|min:6|confirmed:password_confirmation'"
                data-vv-validate-on="blur"
                
              />
            </label>

            <label class="form__label">
              <input
                type="password"
                class="form__credentials-input"
                v-model="credentials.password_confirmation"
                :placeholder="$t('login.confirm_password')"
                name="password_confirmation"
                v-validate="'required'"
                data-vv-validate-on="blur"
                
              />
            </label>

            <div class="form__error" v-if="error.message !== ''">
              <p class="form_error--message">{{ error.message }}</p>
            </div>

            <div class="form__error" v-show="errors.has('password:min')">
              {{ $t('login.password_error') }}
            </div>

            <div class="form__error" v-show="errors.has('password:required')">
              {{ $t('login.password_required') }}
            </div>

            <div class="form__error" v-show="errors.has('password:confirmed') && (fields.fields.password_confirmation && fields.fields.password_confirmation.dirty)">
              {{ $t('login.confirm_password_error') }}
            </div>

            <div class="form__error" v-show="errors.has('password_confirmation:required') && (fields.fields.password && fields.fields.password.valid)">
              {{ $t('login.password_confirmation_required') }}
            </div>

            <button  class="form__login-button btn" @click.stop.prevent="submit()" @keyup.13>
              {{ $t('login.set_new_password') }}
            </button>

          </form>
        </div>

        <div v-if="passwordChanged && !tokenError">
          <div class="successful-icon"></div>
          <h2 class="password-changed">{{ $t('login.password_changed') }}</h2>
          <router-link  :to="{ name: 'login'}" class="form__login-button btn">{{ $t('login.enter_portal') }}</router-link>
        </div>

        <div v-if="tokenError">
          <h2 class="password-error">{{ $t('login.set_password_error_token') }}</h2>
          <router-link :to="{ name: 'reset'}" class="form__login-button btn">{{ $t('login.reset_password') }}</router-link>
        </div>

      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'password-change',
  data() {
    return {
      credentials: {
        email: '',
      },
      isLoading: false,
      error: {
        message: '',
      },
      passwordChanged: false,
      tokenError: false,
    };
  },
  created() {
    this.getUserEmail();
  },
  methods: {
    getUserEmail() {
      this.$http.get(`${process.env.BACKEND_API_URL}api/password/reset/${this.$route.params.token}/${this.$route.params.email}`).then((response) => {
        this.credentials.email = response.data.data.email;
      })
        .catch(() => {
          this.tokenError = true;
          this.error.message = this.$t('login.set_password_error_token');
        });
    },
    submit() {
      this.$validator.validateAll().then((success) => {
        if (success) {
          this.isLoading = true;
          this.credentials.token = this.$route.params.token;
          this.$http.post(`${process.env.BACKEND_API_URL}api/password/reset/`, this.credentials).then((response) => {
            this.isLoading = false;
            if (response.body.status === 'password_changed') {
              this.passwordChanged = true;
            } else {
              this.error.message = this.$t('login.set_password_error');
            }
          })
            .catch(() => {
              this.isLoading = false;
              this.error.message = this.$t('login.set_password_error');
            });
        }
      }).catch(() => {
      });
    },
  },
};
</script>

<style lang="scss">
@import '~styles/app.scss';
.login-screen {

  .successful-icon {
    background-image: url('~icons/done.svg');
    width: 281px;
    height: 300px;
    margin: 0 auto;
    background-repeat: no-repeat;
    animation: jumpInOut 800ms ease-in-out;
  }

  .password-changed {
    font-size: 28px;
    text-align: center;
    display: block;
    margin: -30px 0 50px 0;
  }

  .login-wrapper {
    padding: 20px 60px;

    .header {
      font-weight: 400;
      padding: 0 0 5px 0;
    }

    .login-info {
      font-size: 12px;
      padding: 0 10px;
    }

    .email-address {
      color: var(--brand-orange);
      font-size: 22px;
      padding: 0 10px;
      margin: 35px 0 15px 0;

    }
    .form {
      position: relative;

      &__label {
        width: 100%;
        display: flex;
      }

      &__error {
        margin: 10px 0;
        text-align: center;
        color: var(--brand-red);

        .form_error--message {
          font-weight: 900;
        }
      }

      .form-info {
        margin: 50px 0 10px 0;

        @media screen and (max-width: 480px) {
          display: flex;
        }

        @media screen and (max-height: 740px) {
          margin: 20px 0 5px 0;
        }
        
        &__checkbox {
           display: none;
        }

        &__checkbox + .form-info__custom-checkbox {
          margin: 0 5px 0 15px;
          padding: 7.5px 15px;
          border: solid 1px var(--grey-five);
          cursor: pointer;

          @media screen and (max-height: 740px) {
            padding: 3.75px 12.5px;
          }

         }

        &__checkbox:checked + .form-info__custom-checkbox {
          margin: 0 5px 0 15px;
          width: 30px;
          height: 32px;
          border: solid 1px var(--grey-five);
          cursor: pointer;
          position: relative;

          @media screen and (max-height: 740px) {
            width: 20px;
            height: 22px;
          }

          &:after {
            content: ' ';
            position: absolute;
            top: 4px;
            left: 10px;
            width: 8px;
            height: 16px;
            transform: rotate(45deg);
            border: solid var(--brand-blue);
            border-width: 0 2px 2px 0;
            animation: checkBoxIn 245ms ease-in-out;

            @media screen and (max-height: 740px) {
              top: 3px;
              left: 8.5px;
              width: 5px;
              height: 12px;
            }

          }
        }

        &__checkbox-description {
          color: var(--disabled-color);
          font-size: 14px;
          margin: 0 5px;
          font-weight: 100;

          @media screen and (max-width: 480px) {
            font-size: 10px;
          }

        }

        &__forgot-password {
          font-weight: 700;
          float: right;
          color: var(--brand-blue);
          transition: all 175ms ease-in-out;

          @media screen and (max-width: 480px) {
            font-size: 10px;
            float: clear;
            line-height: 16px;
          }

          &:hover {
            color: var(--brand-orange);
            transition: all 175ms ease-in-out;
          }
        }

        &__remember-me {
          padding: 10px;
        }
      }

      &__error {
        margin: 10px 0;
        text-align: center;
        color: var(--brand-red);

        .form_error--message {
          font-weight: 900;
        }
      }

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/PasswordChange.vue